import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { hideModal } from '../../actions/modal'
import { updateBestGuess, UPDATE_BEST_GUESS } from '../../actions/poolAvailability'
import ModalComponent from '../../components/modal/index'
import PropTypes from 'prop-types'
import { Button, Input, Label, FormGroup, InputGroup, InputGroupAddon } from 'reactstrap'
import { formatMinutes } from '../../helpers/time'

export class UpdateBestGuessModal extends React.Component {

  constructor() {
    super()
    this.updateBestGuess = this.updateBestGuess.bind(this)
    this.onOpened = this.onOpened.bind(this)
    this.state = {
      isUpdateBestGuessButtonDisabled: false,
      bestGuessInMinutes: 0
    }
  }

  isBestGuessValid(value) {
    const valueNumber = Number(value)
    return Math.sign(valueNumber) === 1 && Number.isInteger(valueNumber) && valueNumber < 1440
  }

  updateBestGuess() {
    const bestGuessTimeSpan = formatMinutes(this.state.bestGuessInMinutes, "HH:mm:00")
    this.props.updateBestGuess(this.props.poolId, {
      bestGuess: bestGuessTimeSpan
    }, this.props.partnerId, this.props.partnerSubscriptionId)
  }


  bestGuessValueChanged(newValue) {
    this.setState({
      isUpdateBestGuessButtonDisabled: !this.isBestGuessValid(newValue),
      bestGuessInMinutes: newValue
    })
  }

  onOpened() {
    this.setState({
      isUpdateBestGuessButtonDisabled: true,
      bestGuessInMinutes: 0
    })
  }

  render() {
    if (this.props.isOpen && this.props.modalType === UPDATE_BEST_GUESS) {

      const body = <FormGroup>
        <Label for="bestGuessValue">Enter new Best guess</Label>
        <InputGroup>
          <Input type="number" step="1" id="bestGuessValue" onChange={(e) => this.bestGuessValueChanged(e.target.value)} value={this.state.bestGuessInMinutes} />
          <InputGroupAddon addonType="append">minutes</InputGroupAddon>
        </InputGroup>
        <Button color="link" onClick={() => this.bestGuessValueChanged("15")}>15 mins</Button>
        <Button color="link" onClick={() => this.bestGuessValueChanged("90")}>90 mins</Button>
      </FormGroup>

      const primaryButton = <Button color="primary" id="UpdateBestGuessButton" onClick={this.updateBestGuess} disabled={this.state.isUpdateBestGuessButtonDisabled}>Update</Button>

      return <ModalComponent
        isOpen={this.props.isOpen}
        body={body}
        toggle={this.props.hideModal}
        primaryButton={primaryButton}
        onOpened={this.onOpened} />
    }

    return null
  }
}

const mapStateToProps = state => {
  return {
    isOpen: state.modal.isOpen,
    modalType: state.modal.modalType,
    poolId: state.poolDetails.id,
    partnerSubscriptionId: state.poolDetails.partnerSubscriptionId,
    partnerId: state.poolDetails.partnerId,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  hideModal,
  updateBestGuess
}, dispatch)

UpdateBestGuessModal.propTypes = {
  isOpen: PropTypes.bool,
  modalType: PropTypes.string,
  poolId: PropTypes.string,
  partnerSubscriptionId: PropTypes.string,
  partnerId: PropTypes.string,
  hideModal: PropTypes.func,
  updateBestGuess: PropTypes.func
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateBestGuessModal)



// WEBPACK FOOTER //
// ./src/containers/modal/updateBestGuess.js